import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useState } from 'react';
import Button from '@/components/Button';
import ModalHoc from '@/components/ModalHoc';
import RadioList, { Item as RadioListItem } from '@/components/FormElements/RadioList';
import controlStyles from '@/components/FormElements/styles.module.scss';
import styles from '@/components/ModalHoc/stylesQuestion.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7073 6.29289C16.0978 6.68342 16.0978 7.31658 15.7073 7.70711L11.4144 12L15.7073 16.2929C16.0978 16.6834 16.0978 17.3166 15.7073 17.7071C15.3167 18.0976 14.6836 18.0976 14.293 17.7071L8.58594 12L14.293 6.29289C14.6836 5.90237 15.3167 5.90237 15.7073 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowLeftIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const CalculatorQuestionPresetsModal = _ref => {
  let {
    cta,
    heading,
    options,
    onSubmit = () => undefined
  } = _ref;
  const {
    0: selection,
    1: setSelection
  } = useState('');

  const handleSelection = value => {
    setSelection(value);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs("header", {
      className: styles.container__header,
      children: [/*#__PURE__*/_jsxs("span", {
        className: styles.subBackButton,
        "data-modal": "trigger-close",
        children: [/*#__PURE__*/_jsx(ArrowLeftIcon, {}), "Cancel"]
      }), heading ? /*#__PURE__*/_jsx("h5", {
        className: styles.heading,
        children: heading
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.container__main,
      children: /*#__PURE__*/_jsx(RadioList, {
        className: styles.content,
        children: options.map((option, index) => /*#__PURE__*/_jsxs(RadioListItem, {
          id: `question-preset-${index}`,
          name: "section-option",
          value: option.value,
          onChange: () => handleSelection(option.value),
          checked: Boolean(selection && selection === option.value),
          children: [/*#__PURE__*/_jsx("h6", {
            className: controlStyles.optionsInputHeading,
            children: option.label
          }), option.description ? /*#__PURE__*/_jsx("span", {
            className: clsx(controlStyles.optionsInputSubHeading, controlStyles['optionsInputSubHeading--expanded']),
            children: option.description
          }) : /*#__PURE__*/_jsx(_Fragment, {})]
        }, `question-preset-${index}`))
      })
    }), /*#__PURE__*/_jsxs("footer", {
      className: styles.container__footer,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.linkLikeButton,
        "data-modal": "trigger-close",
        children: "Go Back"
      }), /*#__PURE__*/_jsx(Button, {
        size: "large",
        type: "button",
        onClick: () => onSubmit(selection),
        disabled: !selection,
        children: cta || 'Select'
      })]
    })]
  });
};

export default ModalHoc(CalculatorQuestionPresetsModal, {// modalClass: '',
  // removeOverlay: true,
});